<template>
  <!-- Główny kontener, zawierający sekcję filtrów i wyniki -->
  <div class="content">
    <div class="d-flex filters">
      <!-- Krok 1: komponent filtrów wyświetlany, gdy step === 1 -->
      <FilterCalibrationComponent v-if="step === 1" :from="'calibration'" />
      <!-- Krok 2: wyniki wyświetlane, gdy step !== 1 -->
      <div v-else class="results">
        <!-- Jeżeli mamy jakieś wyniki -->
        <div v-if="results && results.length">
          <!-- Iteracja po każdej lokalizacji w wynikach -->
          <div
            v-for="(locBlock) in results"
            :key="locBlock.location.id"
            class="location-block"
          >
            <!-- Nazwa lokalizacji -->
            <h3>{{ locBlock.location.shortName }}</h3>

            <!-- Iteracja po każdym pasie w danej lokalizacji -->
            <div
              v-for="(laneBlock) in locBlock.lanes"
              :key="laneBlock.lane.id"
              class="lane-block"
            >
              <!-- Numer pasa -->
              <h4>Pas {{ laneBlock.lane.laneNumber }}</h4>

              <!-- TU wykres dla tego pasa -->
              <div class="calibration-graph" v-if="laneBlock.graphBase64">
                <img
                  :src="`data:image/png;base64,${laneBlock.graphBase64}`"
                  alt="Wykres kalibracji pasa"
                  style="max-width:100%; margin-bottom:1rem;"
                />
              </div>

              <!-- Tabela z danymi dla danego pasa -->
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Data i godzina</th>
                    <th>Średni nacisk [kg]</th>
                    <th>Wsp. zmienności [%]</th>
                    <th>Pojazdów [szt]</th>
                    <th>Dewiacja kalibracji [%]</th>
                    <th>Wsp. pewności [%]</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Iteracja po okresach czasowych danego pasa -->
                  <tr
                    v-for="(p, pIdx) in laneBlock.periods"
                    :key="p.dateTime + '-' + pIdx"
                    :class="{ red: p.deviationFromReference > 7 }"
                  >
                    <!-- Formatowana data -->
                    <td>{{ formatDate(p.dateTime) }}</td>
                    <!-- Średni nacisk pierwszej osi lub '-' -->
                    <td>{{ p.firstAxleAvg ?? '-' }}</td>
                    <!-- Współczynnik zmienności lub '-' -->
                    <td>{{ p.firstAxleCov ?? '-' }}</td>
                    <!-- Liczba pojazdów -->
                    <td>{{ p.counter }}</td>
                    <!-- Wartość dewiacji lub '-' -->
                    <td>{{ p.deviationFromReference ?? '-' }}</td>
                    <!-- Wartość pewności lub '-' -->
                    <td>{{ p.confidence ?? '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- Komunikat, gdy brak wyników -->
        <p v-else>Brak wyników</p>
      </div>
    </div>

    <!-- Sekcja przycisków nawigacyjnych: Cofnij / Zastosuj -->
    <div class="d-flex justify-content-between actions">
      <!-- Przycisk "Cofnij" widoczny, gdy step !== 1 -->
      <button
        class="btn-prev"
        v-if="step !== 1"
        @click="back()"
      >
        {{ t('back2').toUpperCase() }}
      </button>
      <!-- Przycisk "Zastosuj" widoczny, gdy step === 1 -->
      <button
        class="btn-next ms-auto"
        v-if="step === 1"
        @click="apply()"
      >
        {{ t('apply').toUpperCase() }}
      </button>
    </div>
  </div>
</template>

<script>
import moment from "moment";                           // biblioteka do formatowania daty
import FilterCalibrationComponent from "./FilterCalibrationComponent";  // komponent filtrów
import CalibrationsService from "@/services/CalibrationsService";      // serwis pobierający dane

// Ustawienie polskiej lokalizacji dla moment.js
moment.locale("pl");

export default {
  name: "CalibrationComponent",  // nazwa komponentu
  components: { FilterCalibrationComponent },
  data() {
    return {
      step: 1,       // aktualny krok: 1 = filtr, 2 = wyniki
      results: null, // tu trzymamy dane pobrane z serwisu
    };
  },
  methods: {
    /**
     * Wywoływane po kliknięciu "Zastosuj" w kroku 1.
     * Pobiera dane i przechodzi do kroku 2.
     */
    apply() {
      CalibrationsService.getCalibrations()
        .then((response) => {
          this.results = response; // zapis odpowiedzi
          this.step = 2;           // przejście do kroku 2
        })
        .catch((error) => {
          console.error("Error fetching calibrations:", error);
        });
    },
    /**
     * Wywoływane po kliknięciu "Cofnij" w kroku 2.
     * Czyści wyniki i wraca do kroku 1.
     */
    back() {
      this.step = 1;
      this.results = null;
    },
    /**
     * Formatowanie daty na format 'DD.MM.YYYY HH:mm'.
     */
    formatDate(dt) {
      return moment(dt).format("DD.MM.YYYY HH:mm");
    },
    /**
     * Alias do tłumaczeń (vue-i18n): zwraca przetłumaczony tekst.
     */
    t(key) {
      return this.$t(key);
    },
  },
};
</script>

<style scoped>
/* Styl głównego kontenera */
.content {
  width: 100%;
  min-height: 270px;
  margin-bottom: 20px;
}
/* Granice sekcji filtrów */
.filters {
  border-top: 1px solid #bbbbbb;
  border-bottom: 1px solid #bbbbbb;
}
/* Styl sekcji wyników */
.results {
  width: 100%;
  padding: 1rem;
  background: #f9f9f9;
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.9rem;
}

/* Kontener przycisków nawigacyjnych */
.actions {
  background-color: white;
  min-height: 43px;
}
/* Wspólny styl przycisków */
.actions button {
  border: 0;
  font-size: 19px;
  font-weight: bold;
  background: none;
}
/* Styl przycisku Zastosuj, z ikonką po prawej */
.actions .btn-next {
  position: relative;
  padding: 8px 40px 8px 8px;
  color: #58585a;
}
.actions .btn-next::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  width: 30px;
  height: 20px;
  background: url("../assets/icons/dalej.png") no-repeat center;
}
.actions .btn-next:hover::after {
  background-image: url("../assets/icons/dalej_over.png");
}
/* Styl przycisku Cofnij */
.actions .btn-prev {
  margin-left: 30px;
  padding: 0 0 0 40px;
  position: relative;
  color: #58585a;
}
.actions .btn-prev:before {
  content: "";
  position: absolute;
  left: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/powrot.png") no-repeat left top;
}
.actions .btn-prev:hover:before {
  background: url("../assets/icons/powrot_over.png") no-repeat left top;
}
/* Podświetlenie wiersza, gdy dewiacja > 7 */
.red td {
  background-color: #f8d7da !important;
}
</style>